import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Radio, TextArea } from '@dbk/ui-forms';
import { List, ListItem } from '@dbk/ui-list';
import Button from '@dbk/ui-buttons';
import { Small } from '../../../components/common/text';
import ScrollableLayout from '../../../components/common/scrollable-layout';
import { LoadingCircle } from '../../../components/common/loading';
import feedbackoptions from '../../../data/feedbackoptions.json';
import BlurModal from '../../../components/common/blur-modal';
class ClientFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      selectedStates: [],
      warningMsg: false,
      rmModal: false,
      displayMsg: '',
      loadingFlag: false,
      comments: '',
      buttonToggle: true
    };

    this.submitRequest = this.submitRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.deselectAll = this.deselectAll.bind(this);
    this.closeFeedback = this.closeFeedback.bind(this);
  }

  componentDidMount() {
    this.setState({ displayMsg: this.props.feedback.displayMsg });

    //this.deselectAll();

    let arrayList = feedbackoptions.options;

    let selectedOptions = [];
    selectedOptions.push(arrayList[0]);

    this.setState({
      selectedStates: selectedOptions
    });

  }

  submitRequest() {
    let { selectedStates, comments } = this.state;

    this.setState({ loadingFlag: true });

    if (comments.length === 0) {
      comments = null;
    }

    let usertype = this.props.feedback.usertype;

    if (usertype.length === 0) {
      usertype = " ";
    }

    let input = {
      "deviceType": "Desktop",
      "starRating": 0,
      "feedbackCateg": selectedStates[0].title,
      "feedbackText": comments.toString(),
      "logoutTriggered": "N",
      "clientAdvisorFlag": usertype
    }

    this.props.sendClientFeedback({ input }).then((success) => {
      this.setState({ rmModal: true });
      this.setState({ loadingFlag: false });
    });
  }

  /*
    function for Deselecting all radiobuttons
  */
  deselectAll() {
    let getList = feedbackoptions.options;

    getList.forEach(function (item, k) {
      item.isChecked = false;
    });
  }

  closeFeedback() {
    this.setState({ rmModal: false });
    this.props.ui.history.goBack();
  }

  handleChange(asset) {
    this.deselectAll();

    let arrayList = feedbackoptions.options;
    let selectedOptions = [];
    arrayList.forEach(function (dataRow, i) {
      if (dataRow.key === asset.key) {
        dataRow.isChecked = true;
        selectedOptions.push(dataRow)
      }
    });

    this.setState({
      selectedStates: selectedOptions
    });
  }

  renderListItems = (item) => {
    const { i18n: { messages } } = this.props;

    return (
      <ListItem testID="list_feedback_clientFeedback_test" onClick={() => this.handleChange(item)} className="profile__list-item">
        <span>
          <Radio className='profile__radio-button' checked={item.isChecked} />
          <span className="profile__list-item-value">
            <span className="profile__list-item-value">{messages[item.title]}</span>
          </span>
        </span>
      </ListItem>
    );
  }

  renderFeedbackOptions = () => {
    const options = feedbackoptions.options;

    return (
      <div className="consolidation__items-wrapper">
        <List className="profile__list" fullWidth>
          {
            options.map((item) => {
              return this.renderListItems(item)
            })
          }
        </List>
      </div>
    );
  }

  modalContent = () => {
    const { feedback: { displayMsg }, i18n: { messages } } = this.props;
    return (
      <div className="profile-modal">
        <span id="msg_feedback_txt_clientFeedback_test" className="profile-modal__info">{displayMsg}</span>
        <div className="profile-modal__action">
          <div className="profile-modal__button-width">
            <Button testID="btn_clientFeedback_okBtn_test" fullWidth onPress={this.closeFeedback}>
              {messages['app.rmcallback.okMsg']}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { feedback: { success }, i18n: { messages } } = this.props;
    const { selectedStates, comments } = this.state;
    let title = '';
    if (success) {
      title = messages['app.feedback.header1'] + ' ' + messages['app.feedback.header2'];
    }
    return (
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="row consolidation">
            <div className="columns small-12 large-12  profile-container">
              <div id="title_feedback_clientFeedback_test" className="profile-container__title">
                <h2>{`${messages['app.feedback.header1']} ${messages['app.feedback.header2']}`}</h2>
              </div>
              <div className="profile-container__info">
                <span>{messages['app.feedback.subTitle']}</span>
              </div>
              <div className="profile__content">
                <p className='profile__content-info'>{messages['app.feedback.subTitleText']}</p>
                <div>
                  {this.renderFeedbackOptions()}
                </div>
                <TextArea
                  id="textarea_feedback_clientFeedback_test"
                  className="feedback__text-area"
                  placeholder={messages['app.feedback.placeholder']}
                  value={comments}
                  spellCheck="false"
                  maxLength={1000}
                  numberOfLines={5}
                  onChange={(ev) => this.setState({ comments: ev.target.value })}
                />
                <div className="max-chars__container">
                  {comments.length === 0 ?
                    <div >
                      <Small>{messages['app.common.marque.max100character']}</Small>
                    </div>
                    :
                    <div >
                      <Small>{1000 - comments.length} {messages['app.common.marque.characterLeft']}</Small>
                    </div>
                  }
                </div>
                <div className='profile__actions-container'>
                  <div className='profile__button--actions-width'>
                    <Button
                      testID="btn_feedback_clientFeedback_test"
                      className="feedback__submit-button"
                      disabled={comments.length < 10 || selectedStates.length === 0}
                      onClick={this.submitRequest}
                      fullWidth
                    >
                      {messages['app.profile.submitFeedback']}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <BlurModal
              visible={this.state.rmModal}
              headerChildren={title}
              onDone={this.closeFeedback}
            >
              {this.modalContent()}
            </BlurModal>
          </div>
        }
      />
    );
  }
}

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      }
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
    sendClientFeedback:
    {
      $call: 'feedback.sendResponse'
    },
    feedback: {
      displayMsg: true,
      success: true,
      checkStatus: true,
      usertype: true,
    },
    ui: {
      history: {
        canGoBack: true,
        goBack: { $call: 'goBack' },
      },
    },
  },
}, ({ app, ...queries }) => ({
  deviceInfo: app.global.deviceInfo,
  ...queries,
}))(ClientFeedback);
